import { Box } from '@chakra-ui/react';

const BoxContainer = ({ children, ...props }) => (
    <Box
        p={'16px 24px'}
        bg={'semantic.100'}
        border={'1px solid'}
        borderColor={'neutral.200'}
        borderRadius={'8px'}
        {...props}
    >
        {children}
    </Box>
);
export default BoxContainer;
